// @flow
// ref: https://medium.com/@rezaduty/how-to-write-secure-code-in-react-937579011d3c
// ref: https://github.com/cure53/DOMPurify
import React from 'react';
import DOMPurify from 'dompurify';

type Props = {
  html: string,
  tagName: string,
  className?: string,
};

export const HTMLView = (props: Props) => {
  const { html, tagName = 'div', className = '' } = props;
  const sanitizedHTML = DOMPurify.sanitize(html);

  return React.createElement(
    tagName,
    {
      dangerouslySetInnerHTML: { __html: sanitizedHTML },
      className,
    },
    null
  );
};
